function fn_comp_detail_head() {
    var $fn = $(".comp_detail_head");

    if ($fn.length) {
        $('<link>').appendTo('head').attr({
            type: "text/css",
            rel: "stylesheet",
            href: "https://cdnjs.cloudflare.com/ajax/libs/chocolat/0.4.19/css/chocolat.min.css"
        });
        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/chocolat/0.4.19/js/jquery.chocolat.min.js").done(function(){
            $('.lib--zoom').addClass("lib--zoom-init").Chocolat({
                imageSize: 'cover',
                imageSelector: '.elm_bike'
            });
        });
    }
}